<span class="currency">{{ type }}</span>
